<section class="about-impact" [ngClass]="{'animate' : showAnimation}" aria-label="Children's Miracle Network impact">
  <div class="about-impact__shell">
    <aside class="about-impact__hero">
      <img
        class="about-impact__hero-image"
        src="assets/images/MBC.svg"
        alt="Make Big Change for all kids"
      />
    </aside>

    <div class="about-impact__content">
      <section class="about-impact__top" aria-label="Network hospitals impact">
        <img
          class="about-impact__stat about-impact__stat--visits"
          src="assets/images/38million.svg"
          alt="Our network hospitals provide 38 million patient visits for 12 million kids every year."
        />
        <img
          class="about-impact__stat about-impact__stat--kids"
          src="assets/images/72kids.svg"
          alt="72 kids are seen by a local children's hospital every minute."
        />
      </section>

      <div class="about-impact__divider" aria-hidden="true"></div>

      <section class="about-impact__daily" aria-label="Daily network hospital care">
        <img
          class="about-impact__daily-heading"
          src="assets/images/everyday.svg"
          alt="Every day, our network hospitals provide care for:"
        />

        <div class="about-impact__care-grid">
          <img
            class="about-impact__care about-impact__care--emergencies"
            src="assets/images/emergencies.svg"
            alt="12,721 kids for emergencies"
          />
          <img
            class="about-impact__care about-impact__care--diabetes"
            src="assets/images/diabetes.svg"
            alt="1,890 kids for diabetes"
          />
          <img
            class="about-impact__care about-impact__care--cancer"
            src="assets/images/cancer.svg"
            alt="1,718 kids for cancer"
          />
          <img
            class="about-impact__care about-impact__care--nicu"
            src="assets/images/nicu.svg"
            alt="814 babies in the NICU or newborn ICU"
          />
        </div>
      </section>

      <div class="about-impact__divider" aria-hidden="true"></div>

      <section class="about-impact__funds" aria-label="Funding impact">
        <img
          class="about-impact__funds-total"
          src="assets/images/10billion.svg"
          alt="Since 1983 Children's Miracle Network partners and programs have raised nearly 10 billion dollars for local children's hospitals across the U.S. and Canada."
        />
        <img
          class="about-impact__funds-use"
          src="assets/images/fundsuse.svg"
          alt="Our network hospitals use the funds where they are needed most."
        />
      </section>

      <footer class="about-impact__footer">
        <span class="about-impact__footer-line" aria-hidden="true"></span>
        <img
          class="about-impact__logo"
          src="assets/images/CMN-Logo-CMYK.svg"
          alt="Children's Miracle Network"
        />
        <span class="about-impact__footer-line" aria-hidden="true"></span>
      </footer>
    </div>
  </div>
</section>
